const NAMESPACE = "deadlinesCapsule";

const KEYS = {
    deadlinesCapsuleTitle: "deadlinesCapsuleTitle",
    setDeadlineLabel: "setDeadlineLabel",
    deadlineToSetLabel: "deadlineToSetLabel",
    noDeadlinesAvailableLabel: "noDeadlinesAvailableLabel",
    deadlineNameHeader: "deadlineNameHeader",
    dueDateHeader: "dueDateHeader",
    statusDescriptionHeader: "statusDescriptionHeader",
    timeLeftHeader: "timeLeftHeader",
    timePausedHeader: "timePausedHeader",
    satisfiedDateHeader: "satisfiedDateHeader",
    noDeadlinesAdminText: "noDeadlinesAdminText",
    noDeadlinesNonAdminText: "noDeadlinesNonAdminText",
    unableToCreateDeadlineMessage: "unableToCreateDeadlineMessage",
    confirmDeadlineStatusChangeMessage: "confirmDeadlineStatusChangeMessage",
    markDeadlineDlgTitle: "markDeadlineDlgTitle",
    satisfiedLabel: "satisfiedLabel",
    unsatisfiedLabel: "unsatisfiedLabel",
    includeSatisfiedDeadlinesLabel: "includeSatisfiedDeadlinesLabel"
};

const MESSAGES = {
    [KEYS.deadlinesCapsuleTitle]: {
        value: "Deadlines",
        comment: "Deadlines capsule label"
    },
    [KEYS.deadlineToSetLabel]: {
        value: "Set deadline",
        comment: "Set deadline label"
    },
    [KEYS.setDeadlineLabel]: {
        value: "Deadline to set:",
        comment: "Ask which deadline to set"
    },
    [KEYS.noDeadlinesAvailableLabel]: {
        value: "No deadline definitions available.",
        comment: "Let user know there are no deadlines available"
    },
    [KEYS.deadlineNameHeader]: {
        value: "Deadline",
        comment: "DeadlineName column header"
    },
    [KEYS.dueDateHeader]: {
        value: "Due Date",
        comment: "DueDate column header"
    },
    [KEYS.statusDescriptionHeader]: {
        value: "Status",
        comment: "StatusDescription column header"
    },
    [KEYS.timeLeftHeader]: {
        value: "Due in",
        comment: "TimeLeft column header"
    },
    [KEYS.timePausedHeader]: {
        value: "Paused for",
        comment: "TimePaused column header"
    },
    [KEYS.satisfiedDateHeader]: {
        value: "End Date",
        comment: "SatisfiedDate column header"
    },
    [KEYS.noDeadlinesAdminText]: {
        value: "No deadlines to display.",
        comment: "Text to display to admin user if there are no deadlines"
    },
    [KEYS.noDeadlinesNonAdminText]: {
        value: "There are no pending deadlines for this project.",
        comment: "Text to display to non-admin user if there are no deadlines"
    },
    [KEYS.unableToCreateDeadlineMessage]: {
        value: "Unable to Create Deadline",
        comment: "Text to display to  user if deadline creation failed"
    },
    [KEYS.confirmDeadlineStatusChangeMessage]: {
        value: "Are you sure you want mark this deadline: ",
        comment: "Confirm with user they want to update deadline status"
    },
    [KEYS.markDeadlineDlgTitle]: {
        value: "Mark Deadline: ",
        comment: "Dialogue confirmation title"
    },
    [KEYS.satisfiedLabel]: {
        value: "satisfied",
        comment: "Was deadline met"
    },
    [KEYS.unsatisfiedLabel]: {
        value: "unsatisfied",
        comment: "was deadline not met"
    },
    [KEYS.includeSatisfiedDeadlinesLabel]: {
        value: "Include satisfied deadlines",
        comment: "Label for checkbox to display satisfied deadlines"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
